<script>
  import { createEventDispatcher } from "svelte";

  let password = "";
  const dispatch = createEventDispatcher();

  function submit() {
    dispatch("authenticate", password);
  }
</script>

<div>
  <input
    type="password"
    bind:value={password}
    placeholder="Enter password"
    on:keydown={e => e.key === "Enter" && submit()}
  />
  <button on:click={submit}>BUILD</button>
</div>

<style>
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }

  input {
    padding: 0.5rem;
    font-size: 1rem;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-top: 20px;
    background-image: url('/brick.png');
    background-color: transparent;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover; /* or contain */
    width: 150px; 
    height: 40px;
    border-radius: 5px;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    cursor: pointer;
  }
  button:hover {
    filter: brightness(1.2);
  }
</style>

